import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { ChangeLogTable, LayoutSidebar, SectionHeader } from 'components';
import { MPContent } from 'screens/MakePayment/components';
import { selectCalculatorChangeLog, selectCalculatorPayees, selectCalculatorPaymentSet, selectCalculatorResults } from 'store/TipCalculator';
import { DisbursementMethod } from 'types';
import { buildTipCalculatorParticipants } from 'utils';
import Summary from '../components/ChangeLog/Summary/Summary';

interface ISharedPosProps {
  onBack: () => void;
  onExpand: () => void;
  pageHeaderContent: React.ReactNode;
  sidebarOpen?: boolean;
}

const ChangeLog = ({ onBack, onExpand, pageHeaderContent, sidebarOpen }: ISharedPosProps) => {
  const payees = useSelector(selectCalculatorPayees());
  const paymentSet = useSelector(selectCalculatorPaymentSet());
  const tipCalcResults = useSelector(selectCalculatorResults());
  const participants = buildTipCalculatorParticipants(tipCalcResults);
  const changeLogEntries = useSelector(selectCalculatorChangeLog());

  const summary = useMemo(() => {
    let totalHoldbacks = 0;
    let totalInstant = 0;
    let totalPayroll = 0;
    let total = 0;

    payees?.forEach((payee) => {
      totalHoldbacks += payee?.employee?.disbursementMethod === DisbursementMethod.INSTANT ? payee.holdbackAmount : 0;
      totalInstant += payee?.employee?.disbursementMethod === DisbursementMethod.INSTANT ? payee.gross - payee.holdbackAmount : 0;
      totalPayroll += payee?.employee?.disbursementMethod === DisbursementMethod.PAYROLL ? payee.gross : 0;
      total += payee.gross;
    });

    return (
      <Summary
        onExpand={onExpand}
        onBack={onBack}
        paymentDate={dayjs(paymentSet.date)}
        totalHoldbacks={totalHoldbacks}
        sidebarOpen={sidebarOpen}
        totalInstantTips={totalInstant}
        totalPayrollTips={totalPayroll}
        totalTips={total}
        participants={participants}
      />
    );
  }, [sidebarOpen]);

  return (
    <LayoutSidebar
      content={
        <>
          {pageHeaderContent}
          <MPContent data-cy="change-log-content">
            <SectionHeader data-cy="change-log-header" title={`Changes (${changeLogEntries.length})`} />
            <ChangeLogTable changeLogEntries={changeLogEntries} />
          </MPContent>
        </>
      }
      sidebar={summary}
      sidebarOpen={sidebarOpen}
    />
  );
};

export default ChangeLog;
